import {
  Button,
  Card,
  Group,
  LoadingOverlay,
  Stack,
  Title,
} from '@mantine/core';
import { useFetch } from '@mantine/hooks';
import { useNavigate } from 'react-router-dom';
import { useAuthUser } from '../../../providers/AuthProvider';
import { getAppColor } from '../../../utils/getAppColor';

interface Product {
  id: number;
  product_id: number;
  name: string;
}

export function ActiveSubscriptions() {
  const user = useAuthUser();
  const userId = user?.id;
  const navigate = useNavigate();

  const { data, loading } = useFetch<{ data: Product[] }>(
    userId
      ? `${import.meta.env.VITE_API_URL}/services/admin/users/${userId}/products`
      : '',
    {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  const activeSubscriptions: Product[] = Array.isArray(data?.data)
    ? data.data.filter(item => item.product_id >= 75 && item.product_id <= 81)
    : [];

  const subscriptionOrder = [
    'Augmented Wellbeing',
    'Augmented Psychology',
    'Augmented Situations',
    'Augmented Mentalization',
    'Augmented Exposure',
    'Augmented Performance',
    'Augmented Corporate',
  ];

  const orderedActiveSubscriptions = [...activeSubscriptions].sort(
    (a, b) =>
      subscriptionOrder.indexOf(a.name) - subscriptionOrder.indexOf(b.name)
  );

  return (
    <Card shadow='sm' withBorder p='sm' radius='sm'>
      <Title order={4} mb='sm'>
        Abbonamenti attivi
      </Title>
      <LoadingOverlay visible={loading} />

      <Stack gap='sm'>
        {orderedActiveSubscriptions.map(sub => (
          <Card
            key={sub.id}
            p='md'
            radius='sm'
            style={{ background: getAppColor(sub.name) }}
          >
            <Group justify='space-between'>
              <Title c='white' order={5}>
                {sub.name}
              </Title>
              <Button
                onClick={() => navigate('/sessions')}
                color='white'
                variant='outline'
              >
                Configura
              </Button>
            </Group>
          </Card>
        ))}

        {activeSubscriptions.length === 0 && (
          <Title order={6} c='gray'>
            Nessun abbonamento attivo
          </Title>
        )}
      </Stack>
    </Card>
  );
}
